import type { FC, ReactNode } from 'react';

import { Box } from '@mui/material';

import { darkGradientContainerSx, centeredContentWrapperSx } from '../shared/constants';

interface BaseLayoutProps {
  children: ReactNode;
}

/**
 * Base layout component providing dark gradient background and centered content wrapper.
 * This is the foundational layout used for pages that need the standard dark theme styling.
 */
export const BaseLayout: FC<BaseLayoutProps> = ({ children }) => (
  <Box sx={darkGradientContainerSx}>
    <Box
      sx={{
        ...centeredContentWrapperSx,
        p: 4
      }}
    >
      {children}
    </Box>
  </Box>
);
